module.exports = __webpack_public_path__ + "static/img/bg-ar.3daa9130.png";